import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/new/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = '/deals/new';

const New: NextPage = () => (
  <>
    <NskHead title="案件追加" />
    <Component />
  </>
);

export default New;
